<template>
    <div>
        <h5>Histórico de Status</h5>

        <div class="container-fluid pt-2 pb-5">

            <b-row class="align-items-center mb-4 justify-content-end">
                <b-col cols="auto">
                    <b-input-group>
                        <template #prepend>
                            <b-input-group-text>Ver</b-input-group-text>
                        </template>
                        <b-form-select
                            :options="[
                                { value: 'Todos', text: 'Todos' },
                                { value: 'Aprovacao', text: 'Apenas Aprovações' },
                                { value: 'Devolucao', text: 'Apenas Devoluções' },
                            ]"
                            v-model="filtro"
                            text-field="text"
                            value-field="value"
                        ></b-form-select>
                    </b-input-group>
                </b-col>
            </b-row>

            <div class="row">
                <div class="col">
                    <div class="border-left border-secondary pl-4 position-relative">
                        <!-- Linha vertical -->
                        <div class="position-absolute bg-secondary" style="width: 1px; top: 0; bottom: 0; left: 0;">
                        </div>

                        <!-- Itens -->
                        <div v-for="(item, index) in historicoMedicao" :key="index" class="position-relative mb-5 pl-4">
                            <div v-if="exibir(item.status)" class="position-absolute" style="top: 15; left: -52px">
                                <div class="col-md-4 mb-4">
                                    <div class="rounded-circle bg-history-circle d-flex align-items-center justify-content-center mx-auto"
                                        style="width: 35px; height: 35px;">
                                        <div class="rounded-circle bg-history-point" style="width: 12px; height: 12px;">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="exibir(item.status)" class="card shadow-sm">
                                <div class="card-body">
                                    <b-row>
                                        <b-col class="col-10">
                                            <div class="font-weight-bold">
                                                <b-badge v-if="item.resultadosEnvioSei && item.resultadosEnvioSei.length" variant="success">
                                                    <span class="h6 text-uppercase ml-1 mr-1">
                                                        Documentos Enviados para o SEI
                                                    </span>
                                                </b-badge>
                                                <b-badge v-else :variant="obterClasseCorStatusBoletimMedicao(item.status)">
                                                    <span class="h6 text-uppercase ml-1 mr-1">
                                                        BM {{ obterDescricaoStatusBoletimMedicao(item.status) }}
                                                    </span>
                                                </b-badge>
                                            </div>
                                            <div class="font-weight-bold text-uppercase mt-1"> {{ item.responsavel }} </div>
                                            <div class="card-text mt-1"> {{ item.mensagem }}</div>
                                            <div v-if="item.anexos && item.anexos.length" class="card-text mt-1">
                                                <b-button v-for="(anexo, index) in item.anexos" :key="index"
                                                    pill
                                                    variant="light"
                                                    class="mr-2"
                                                    v-b-tooltip.hover
                                                    title="Clique para fazer o download"
                                                    @click="downloadAnexo(anexo)"
                                                >
                                                    <i class="fa fa-paperclip"></i> {{ anexo.nomeArquivo }} ({{ anexo.tamanho | tamanhoArquivoFormatado }})
                                                </b-button>
                                            </div>
                                            <div v-if="item.resultadosEnvioSei && item.resultadosEnvioSei.length" class="mt-2">
                                                <b-button
                                                    variant="link"
                                                    size="sm"
                                                    class="p-0 text-secondary"
                                                    @click="toggleResultadosSei(item.historicoBoletimMedicaoId)"
                                                >
                                                    <i :class="expandidosSei[item.historicoBoletimMedicaoId] ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                                                    {{ item.resultadosEnvioSei.length }} documento(s)
                                                </b-button>
                                                <div v-if="expandidosSei[item.historicoBoletimMedicaoId]" class="mt-1">
                                                    <div
                                                        v-for="(res, idx) in item.resultadosEnvioSei"
                                                        :key="idx"
                                                        class="d-flex align-items-center mt-1"
                                                    >
                                                        <i
                                                            :class="res.sucesso ? 'fa fa-check-circle text-success' : 'fa fa-times-circle text-danger'"
                                                            class="mr-2"
                                                        ></i>
                                                        <span class="mr-2">{{ res.nomeDocumento }}</span>
                                                        <small v-if="res.mensagem" class="text-muted">— {{ res.mensagem }}</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-col>

                                        <b-col>
                                            <div class="float-right"> {{ item.data | toDateTime }} </div>
                                        </b-col>
                                    </b-row>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { 
    obterDescricaoStatusBoletimMedicao,
    obterClasseCorStatusBoletimMedicao,
    statusBoletinsMedicao,
 } from '../../BoletimMedicao.js';
import BoletimMedicaoServicos from '../../BoletimMedicaoServicos.js'

export default {

    props: {
        historicoMedicao: {
            type: Array,
            default: () => []
        },
        boletimMedicao: {
            type: Object,
            default: {}
        },
        contrato: {
            type: Object,
            default: {}
        },
    },

    data() {
        return {
            filtro: 'Todos',
            expandidosSei: {}
        }
    },

    computed: {

    },

    methods: {
        obterDescricaoStatusBoletimMedicao,
        obterClasseCorStatusBoletimMedicao,

        toggleResultadosSei(historicoId) {
            this.$set(this.expandidosSei, historicoId, !this.expandidosSei[historicoId])
        },

        downloadAnexo(documentoHistoricoBoletimMedicao) {
            this.$store.dispatch('addRequest')

            BoletimMedicaoServicos.downloadAnexoHistoricoBoletimMedicao(this.contrato.contratoId, this.boletimMedicao.boletimMedicaoId, documentoHistoricoBoletimMedicao.documentoHistoricoBoletimMedicaoId)
                .then(response => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Não foi possível fazer o download do arquivo',
                                'Erro',
                                this.$toastConfig.error
                            )
                        } else {
                            this.$download(response, documentoHistoricoBoletimMedicao.nomeArquivo)
                        }
                    } else {
                        this.erros = response.errors
                    }

                    this.$store.dispatch('removeRequest')
                })
                .catch(error => {
                    this.$toast.error(
                        'Não foi possível fazer o download do arquivo',
                        'Erro',
                        this.$toastConfig.error
                    )
                    this.$store.dispatch('removeRequest')
                })
        },

        exibir(status) {
            return this.filtro === 'Todos' || this.filtro === statusBoletinsMedicao[status]?.grupoFiltro;
        },
    }
}
</script>

<style scoped>
.bg-history-circle {
    background: #FEF9C3;
}

.bg-history-point {
    background: #CA8A04;
}
</style>